<script>
export default {
  computed: {
    items() {
      const steps = [
        {
          title: 'Detalles',
          body: 'Nombre y descripción',
          route: 'settings_branches_edit',
        },
        {
          title: 'Agentes',
          body: 'Gestionar agentes',
          route: 'settings_branches_edit_members',
        },
        {
          title: 'Equipos',
          body: 'Gestionar equipos',
          route: 'settings_branches_edit_teams',
        },
        {
          title: 'Finalizar',
          body: 'Listo',
          route: 'settings_branches_edit_finish',
        },
      ];

      return steps.map(step => {
        return {
          title: step.title,
          body: step.body,
          route: step.route,
        };
      });
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-6 mb-8 max-w-7xl mx-auto w-full !px-6">
    <div class="rounded-xl border border-n-weak h-full min-h-[50dvh] w-full">
      <router-view />
    </div>
  </div>
</template>
